
import axios from "axios";
import { useAuth } from "../navigation/AuthProvider";
import { BACKEND_URL } from "../constants";





export const send_password_mail_to_new_employee = async ({newEmployeeName, newEmployeeRole, newEmployeeEmail, user, company}) => {
    if(!user) return 

    const newUserData = {
        email: newEmployeeEmail,
        name: newEmployeeName,
        role: newEmployeeRole
    }

    const { data } = await axios.post(`${BACKEND_URL}/send-password-mail-to-new-employee`, {
        userId: user._id,
        companyId: company._id,
        newUser: newUserData
    }, {withCredentials: true})
    return data
}

export const resend_invite = async ({user, company, employee}) => {

}

export const add_new_employee = async ({newEmployeeName, newEmployeeRole, newEmployeeEmail, user, company}) => {

    if(!user) return void null
    console.log(user, company)

    const newUser = {
        name: newEmployeeName,
        email: newEmployeeEmail,
        role: newEmployeeRole,
    }

    
    const { data } = await axios.post(`${BACKEND_URL}/add-new-employee`, { 
        newUser,
        current_users_id: user._id,
        companyId: company._id
    }, { withCredentials: true })
    return data

}



export const delete_employee = async ({user, company, employeeToRemoveId}) => {

    if(!user) return void null

    const { data } = await axios.post(`${BACKEND_URL}/remove-employee-from-company`, {
        companyId: company._id,
        current_usersId: user._id,
        employeeToRemoveId
    }, {withCredentials: true})

    return data
}




export const edit_employee = async ({user, company, employeeToEditId, editedFields}) => {

    if(!user || !company || !employeeToEditId) void null

    const { data } = await axios.post(`${BACKEND_URL}/edit-company-employee`, {
        userId: user._id,
        companyId: company._id,
        employeeToEditId,
        editedFields
    }, { withCredentials: true })

    return data
}





export const get_employees_hours_for_month = async ({ user, company, month, year }) => {
    if (!user || !company || !month || !year) {
      alert("Kunde inte kolla timmar för månaden!");
      return { status: "failure", errorText: "Missing parameters" };
    }
  
    try {
      const { data } = await axios.post(`${BACKEND_URL}/get-employe-hours-for-month`, {
        userId: user._id,
        companyId: company._id,
        month,
        year
      }, { withCredentials: true });
  
      return data;
    } catch (error) {
      console.error("Error fetching employee hours:", error);
      return { status: "failure", errorText: "Could not fetch employee hours" };
    }
  }

  




export const change_employee_hourly_rate = async ({ user, company, newHourlyRate }) => {
    if(!user || !company || !newHourlyRate) {
        alert("Kunde inte ändra timmarna")
        return { status: "failure", errorText: "Missing parameters"}
    }

    try{
        const { data } = await axios.post(`${BACKEND_URL}/chnage-employee-hourly-rate`, {
            userId: user._id,
            companyId: company._id,
            newHourlyRate
        }, {withCredentials: true})
        
        return data

    }

    catch(error) {
        return alert(error)
    }
}





export const deactivate_employee = async ({ user, company, employeeId }) => {
  if (!user || !company || !employeeId) return;

  const { data } = await axios.post(
    `${BACKEND_URL}/deactivate-employee`,
    {
      userId: user._id,
      companyId: company._id,
      employeeId
    },
    { withCredentials: true }
  );

  return data;
};




export const reactivate_employee = async ({ user, company, employeeId }) => {
  if (!user || !company || !employeeId) return;

  const { data } = await axios.post(
    `${BACKEND_URL}/reactivate-employee`,
    {
      userId: user._id,
      companyId: company._id,
      employeeId
    },
    { withCredentials: true }
  );

  return data;
};